// extracted by mini-css-extract-plugin
export default {"container":"SpeedMathGame_container__80YJ2","gameContainer":"SpeedMathGame_gameContainer__okaJS"};